/* import __COLOCATED_TEMPLATE__ from './public-banner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();